export default {
  setRecentSearchKeyword(state, keyword) {
    let keywords = [...state.recentSearchKeywordList];

    // 기존 최근검색어 리스트에 검색된 keyword가 없을 경우에만 저장
    if (
      state.recentSearchKeywordList.filter((item) => item === keyword)
        .length === 0
    ) {
      keywords = [keyword, ...state.recentSearchKeywordList];
    }
    // 최근검색어 10개 slice
    keywords.slice(0, 10);

    state.recentSearchKeywordList = keywords;
  },

  spliceByIndex(state, index) {
    state.recentSearchKeywordList.splice(index, 1);
  },

  recentSearchDeleteAll(state) {
    state.recentSearchKeywordList = [];
  },

  setRecommendedKeyword(state, response) {
    state.recommendedKeywordList = response;
  },

  setKeywordRank(state, response) {
    state.keywordRankList = response;
  },

  /* ------------------------------- Filter setter ------------------------------- */

  resetFilter(state) {
    state.filter = {
      // latitude: '',
      // longitude: '',
      STORE_ORDER_BY_CONDITION: '',
      STORE_DELIVERY_FEE_CONDITION: '',
      STORE_REQUIRED_PAY_AMOUNT_CONDITION: '',
      STORE_STAR_CONDITION: '',
      STORE_ETC_CONDITION: []
    };
  },
  setSelectFilter(state, condition) {
    if (condition.key === 'STORE_ORDER_BY_CONDITION') {
      state.filter['STORE_ORDER_BY_CONDITION'] = condition.value;
    }

    if (condition.key === 'STORE_DELIVERY_FEE_CONDITION') {
      state.filter['STORE_DELIVERY_FEE_CONDITION'] = condition.value;
    }

    if (condition.key === 'STORE_REQUIRED_PAY_AMOUNT_CONDITION') {
      state.filter['STORE_REQUIRED_PAY_AMOUNT_CONDITION'] = condition.value;
    }

    if (condition.key === 'STORE_STAR_CONDITION') {
      state.filter['STORE_STAR_CONDITION'] = condition.value;
    }
  },

  setCheckBoxFilter(state, etcOptionList) {
    state.filter['STORE_ETC_CONDITION'] = etcOptionList;
  }
};
